export const ERROR = {
  UNABLE_TO_RECORD_ACTION: 'Unable to record action',
  DISABLED_ELEMENT: 'Element is disabled',
} as const;

export const VM_BROWSER_USER_NAME = 'browser' as const;

export const DEFAULT_DELAY_MS = 50;
